import { Button, Flex, Typography } from "antd";
import { NavLink } from "react-router-dom";

const NavBar = () => {
  return (
    <Flex justify='space-between' align="center" style={{ width: '100%', padding: '10px' }}>
      <NavLink to="/faq"><Button size="large" type="primary">FAQ</Button></NavLink>
      <NavLink to="/"><Typography.Title level={3} style={{ margin: 0 }}>L & R</Typography.Title></NavLink>
      <NavLink to="/registry"><Button size="large" type="primary">Registry</Button></NavLink>
    </Flex>
  );
};

export default NavBar;